import { Lock01 } from "@untitledui/icons";

export const BrandModeLockedNotice = () => {
  return (
    <div className="flex items-center gap-md rounded-xl border border-secondary p-xl">
      <Lock01 className="size-5 shrink-0 text-tertiary" />
      <span className="text-sm font-semibold text-secondary">
        Switch to featured brand mode to customize
      </span>
    </div>
  );
};
